import { useModal } from '@ebay/nice-modal-react';
import { Box, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { ModalDrawer } from '@ocx-app/components/modals';
import { Button, Note, QRCode, SizingMultiplier, Typography } from '@ocx/ui';
import { InfoOutlinedIcon } from '@ocx/ui-icons';
import { buttonTextMessages } from '@ocx-app/modules/localization/button-text.messages';

import { messages } from './loyalty-id-qr-code-scan-action-sheet.messages';
import { LoyaltyIdQrCodeScanActionSheetControllerProps } from './loyalty-id-qr-code-scan-action-sheet.types';

const QR_CODE_CANVAS_SIZE_PX = 178;

export const LoyaltyIdQrCodeScanActionSheetController = ({
  qrValue,
}: LoyaltyIdQrCodeScanActionSheetControllerProps) => {
  const modal = useModal();

  return (
    <ModalDrawer open={modal.visible} onClose={modal.hide} onExited={modal.remove}>
      <Stack alignItems="justify" p={SizingMultiplier.lg}>
        <Box display="flex" justifyContent="center" mb={SizingMultiplier.md}>
          <QRCode text={qrValue} canvasSize={QR_CODE_CANVAS_SIZE_PX} />
        </Box>

        <Typography variant="h5" component="h2" gutterBottom>
          <FormattedMessage {...messages.title} />
        </Typography>
        <Typography>
          <FormattedMessage {...messages.description} />
        </Typography>

        <Stack
          direction="row"
          component={Note}
          my={SizingMultiplier.md}
          spacing={SizingMultiplier.sm}
          alignItems="center">
          <InfoOutlinedIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
          <Stack>
            <Typography variant="caption" color="textSecondary">
              <FormattedMessage {...messages.reminderTitle} />
            </Typography>
            <Typography variant="caption" color="textSecondary">
              <FormattedMessage {...messages.reminderDescription} />
            </Typography>
          </Stack>
        </Stack>

        <Button variant="text" onClick={modal.hide}>
          <FormattedMessage {...buttonTextMessages['button-text:close']} />
        </Button>
      </Stack>
    </ModalDrawer>
  );
};
